import { SchedulerDayColumn, ShiftSiblingData } from '@lp/features/Scheduler/types';
import { DayCell } from '@lp/features/Scheduler/components';
import { CCShiftOptionType } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/types';
import { CCShiftCell, CCShiftEmptyCell } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/components';
import { CCShift, CCShiftSelectPayload } from '@/api/apis/resources/schedule';
import { NameByValue } from '@/types';

type CCDayCellProps = {
  column: SchedulerDayColumn;
  shiftData: CCShift;
  dropdownList: NameByValue<CCShiftOptionType>[];
  siblingData?: ShiftSiblingData;
  isEditable: boolean;
  canReset: boolean;
  highlight?: boolean;
  canUnblock?: boolean;
  onShiftChange: (shiftPayload?: CCShiftSelectPayload) => void;
  onUnblock?: () => void;
};

export const CCDayCell = ({
  column,
  shiftData,
  dropdownList,
  siblingData,
  isEditable,
  canReset,
  highlight,
  canUnblock,
  onShiftChange,
  onUnblock,
}: CCDayCellProps) => {
  const readonly = !isEditable || !column.isCurrentMonth;

  return (
    <DayCell
      active={column.isSelectedDay}
      highlight={highlight}
      hasPrev={siblingData?.hasPrev}
      hasNext={siblingData?.hasNext}
    >
      {shiftData ? (
        <CCShiftCell
          shiftData={shiftData}
          dropdownList={dropdownList}
          siblingData={siblingData}
          lighten={!column.isCurrentMonth}
          readonly={readonly}
          canReset={canReset}
          canUnblock={canUnblock}
          onShiftChange={onShiftChange}
          onUnblock={onUnblock}
        />
      ) : (
        !readonly && <CCShiftEmptyCell dropdownList={dropdownList} onShiftChange={onShiftChange} />
      )}
    </DayCell>
  );
};
